export default __webpack_public_path__ + "static/media/ico_donde.0b7672ef.svg";